export const SupplierRequests = [
  {
    request_type: "Add New Buyer",
    label: "Add New Buyer",
    value: "add_buyer",
    categories: [],
  },
  {
    request_type: "Amend 129 Knots PO Details",
    label: "Amend 129 Knots PO Details",
    value: "129_knots_po",
    categories: [
      {
        value: "deal_specific_tcs",
        label: "Deal Specific T&Cs",
        sub_categories: [
          {
            value: "other",
            label: "Other",
          },
        ],
      },
      {
        value: "other",
        label: "Other",
      },
    ],
  },
  {
    request_type: "Amend BDN",
    label: "Amend BDN",
    value: "bdn",
    categories: [
      {
        value: "wrong_file_uploaded",
        label: "Wrong file uploaded",
      },
      {
        value: "incorrect_information",
        label: "Incorrect information",
      },
      {
        value: "other",
        label: "Other",
      },
    ],
  },
  {
    request_type: "Amend Deal Confirmation",
    label: "Amend Deal Confirmation",
    value: "amend_deal_confirmation",
    categories: [
      {
        value: "rfq_details",
        label: "RFQ details",
      },
      {
        value: "agent_details",
        label: "Agent Details",
      },
      {
        value: "quantity_offer_details",
        label: "Offer Details - Quantity",
      },
      {
        value: "product_quality_offer_details",
        label: "Offer Details - Product/Quality",
      },
      {
        value: "price_offer_details",
        label: "Offer Details - Price/unit",
      },
      {
        value: "deal_specific_tcs",
        label: "Deal Specific T&Cs",
      },
      {
        value: "other",
        label: "Other",
      },
    ],
  },
  {
    request_type: "Amend Payment Confirmation",
    label: "Amend Payment Confirmation",
    value: "amend_payment_confirmation",
    categories: [
      {
        value: "first_payment",
        label: "First Payment",
        sub_categories: [
          {
            value: "address",
            label: "Address",
          },
          {
            value: "due_date",
            label: "Due date",
          },
          {
            value: "currency",
            label: "Currency",
          },
          {
            value: "amount",
            label: "Amount",
          },
          {
            value: "other",
            label: "Other",
          },
        ],
      },
      {
        value: "second_payment",
        label: "Second Payment",
        sub_categories: [
          {
            value: "address",
            label: "Address",
          },
          {
            value: "due_date",
            label: "Due date",
          },
          {
            value: "currency",
            label: "Currency",
          },
          {
            value: "amount",
            label: "Amount",
          },
          {
            value: "other",
            label: "Other",
          },
        ],
      },
    ],
  },
  {
    request_type: "Amend Supplier Invoice",
    label: "Amend Supplier Invoice",
    value: "supplier_invoice",
    categories: [
      {
        value: "wrong_file_uploaded",
        label: "Wrong file uploaded",
      },
      {
        value: "address",
        label: "Address",
      },
      {
        value: "due_date",
        label: "Due date",
      },
      {
        value: "currency",
        label: "Currency",
      },
      {
        value: "qty",
        label: "QTY",
      },
      {
        value: "invoice_amount",
        label: "Invoice Amount",
      },
      {
        value: "other",
        label: "Other",
      },
    ],
  },
  {
    request_type: "Amend Supplier SO",
    label: "Amend Supplier SO",
    value: "supplier_so",
    categories: [
      {
        value: "wrong_file_uploaded",
        label: "Wrong file uploaded",
      },
      {
        value: "incorrect_information",
        label: "Incorrect information",
      },
      {
        value: "other",
        label: "Other",
      },
    ],
  },
  {
    request_type: "Credit Limit Extension",
    label: "Credit Limit Extension",
    value: "credit_limit_extension",
    categories: [],
  },
  {
    request_type: "Deal Financing",
    label: "Deal Financing",
    value: "deal_financing",
    categories: [],
  },
  {
    request_type: "Invoice Financing",
    label: "Invoice Financing",
    value: "invoice_financing",
    categories: [],
  },
  {
    request_type: "Offer Limit Extension",
    label: "Offer Limit Extension",
    value: "offer_limit_extension",
    categories: [],
  },
  {
    request_type: "Query",
    label: "Query",
    value: "query",
    categories: [],
  },
  {
    request_type: "Raise a Dispute - Cancel Transaction",
    label: "Raise a Dispute - Cancel Transaction",
    value: "order_cancellation",
    categories: [
      {
        value: "lack_of_inventory",
        label: "Lack of Inventory",
      },
      {
        value: "other",
        label: "Other",
      },
    ],
  },
  {
    request_type: "Request Ad-hoc Report",
    label: "Request Ad-hoc Report",
    value: "adhoc_report",
    categories: [],
  },
];
